/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{useEffect as e,useLayoutEffect as r}from"react";import{env as o}from"../utils/env.js";let s=(s,t)=>{o.isServer?e(s,t):r(s,t)};export{s as useIsoMorphicEffect};
//# sourceMappingURL=use-iso-morphic-effect.js.map
